var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCanadianMapleLeafBrands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.073,
    height: 17.659,
    viewBox: "0 0 16.073 17.659",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "canadian-maple-leaf-brands",
    d: "M35.444,12.13c.086-.086,3.628-3.187,3.628-3.187l-.6-.259c-.345-.169-.255-.4-.172-.6.083-.262.693-2.321.693-2.321s-1.645.345-1.99.431c-.259.083-.345-.086-.431-.259s-.517-1.117-.517-1.117-1.814,2.066-1.9,2.149c-.345.259-.693,0-.607-.345,0-.345.952-4.47.952-4.47s-1.038.6-1.383.773c-.259.172-.435.172-.607-.172C32.33,2.494,31.033,0,31.033,0s-1.293,2.494-1.466,2.752c-.172.345-.345.345-.607.172-.345-.172-1.383-.773-1.383-.773s.952,4.125.952,4.47c.086.345-.259.6-.607.345-.086-.086-1.9-2.149-1.9-2.149s-.431.942-.517,1.114-.172.341-.431.259c-.348-.086-1.99-.431-1.99-.431s.607,2.059.693,2.321c.083.207.172.431-.172.6l-.6.262s3.539,3.1,3.628,3.187c.176.172.345.259.176.776s-.348,1.211-.348,1.211,3.283-.693,3.632-.779c.3-.031.631.086.631.431s-.2,3.891-.2,3.891h1.035s-.2-3.542-.2-3.891.328-.462.635-.431c.345.086,3.628.779,3.628.779s-.172-.693-.345-1.211S35.272,12.3,35.444,12.13Z",
    transform: "translate(-23)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanadianMapleLeafBrands);
export default __webpack_public_path__ + "static/media/canadian-maple-leaf-brands.3043cd6d7e93162ee22f61e851abef15.svg";
export { ForwardRef as ReactComponent };